import React, { useEffect } from 'react';
import '../Options.css';
import FilledCheckbox from '../../../App/Common/Inputs/Checkboxes/FilledCheckbox/FilledCheckbox';


const MultiChoice = ({ options, setAnswers, answers, questionId }) => {
    const checkBox = () => {
        let checkedBoxes = document.querySelectorAll('input:checked')
        let checkedBoxesArray = Array.prototype.slice.call(checkedBoxes)
        let checkedOptionsIds = checkedBoxesArray.map(i => i.id)
        setAnswers(checkedOptionsIds)
    }

    useEffect(() => {
        setAnswers(answers)
    }, [])
// console.log(answers?.includes('190'))
    return (
        <fieldset>
            {options.map((option, index) => (
                <div className='multiChoice__option' key={option.id}>
                    <FilledCheckbox option={option} onClickAction={checkBox} isChecked={answers && answers.find(a => a == option.id)} />
                </div>
            ))
            }
        </fieldset>

    )
}
export default MultiChoice
